function numberToReal(numero) {
  var numeroAux = numero.toFixed(2).split(".");
  numeroAux[0] = "R$ " + numeroAux[0].split(/(?=(?:...)*$)/).join(".");
  return numeroAux.join(",");
}

function leech(v) {
  v = v.replace(/o/gi, "0");
  v = v.replace(/i/gi, "1");
  v = v.replace(/z/gi, "2");
  v = v.replace(/e/gi, "3");
  v = v.replace(/a/gi, "4");
  v = v.replace(/s/gi, "5");
  v = v.replace(/t/gi, "7");
  return v;
}

function soNumeros(v) {
  return v.replace(/\D/g, "");
}

function telefone(v) {
  v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
  v = v.replace(/^(\d\d)(\d)/g, "($1) $2"); //Coloca parênteses em volta dos dois primeiros dígitos
  v = v.replace(/(\d{4})(\d)/, "$1-$2"); //Coloca hífen entre o quarto e o quinto dígitos
  return v;
}

function cpf(v) {
  v = v.replace(/\D/g, ""); //Remove tudo o que não é dígito
  v = v.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
  v = v.replace(/(\d{3})(\d)/, "$1.$2"); //Coloca um ponto entre o terceiro e o quarto dígitos
  //de novo (para o segundo bloco de números)
  v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2"); //Coloca um hífen entre o terceiro e o quarto dígitos
  return v;
}

function cep(v) {
  v = v.replace(/D/g, ""); //Remove tudo o que não é dígito
  v = v.replace(/^(\d{5})(\d)/, "$1-$2"); //Esse é tão fácil que não merece explicações
  return v;
}

function mdata(v) {
  v = v.replace(/\D/g, "");
  v = v.replace(/(\d{2})(\d)/, "$1/$2");
  v = v.replace(/(\d{2})(\d)/, "$1/$2");

  v = v.replace(/(\d{2})(\d{2})$/, "$1$2");
  return v;
}

function mcc(v) {
  v = v.replace(/\D/g, "");
  v = v.replace(/^(\d{4})(\d)/g, "$1 $2");
  v = v.replace(/^(\d{4})\s(\d{4})(\d)/g, "$1 $2 $3");
  v = v.replace(/^(\d{4})\s(\d{4})\s(\d{4})(\d)/g, "$1 $2 $3 $4");
  return v;
}

function cga(value) {
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  let removeZero = parseInt(value, 10);
  var v = removeZero.toString();
  if (v.length === 11) {
    //000.000/000-00
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d)/, "$1/$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 10) {
    // 00.000/000-00
    v = v.replace(/(\d{2})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d)/, "$1/$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 9) {
    // 0.000/000-00
    v = v.replace(/(\d{1})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d)/, "$1/$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 8) {
    // 000/000-00
    v = v.replace(/(\d{3})(\d)/, "$1/$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 7) {
    // 0/0000-00
    v = v.replace(/(\d{1})(\d)/, "$1/$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 6) {
    // 0000-00
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 5) {
    // 000-00
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 4) {
    // 00-00
    v = v.replace(/(\d{2})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 3) {
    // 0-00
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1-$2");
  }

  return v;
}

function imoveis(value) {
  value = value.replace(/\D/g, ""); //Remove tudo o que não é dígito
  let removeZero = parseInt(value, 10);
  var v = removeZero.toString();

  if (v.length === 7) {
    // 000.000-0
    v = v.replace(/(\d{3})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 6) {
    // 00.000-0
    v = v.replace(/(\d{2})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 5) {
    // 0.000-0
    v = v.replace(/(\d{1})(\d)/, "$1.$2");
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  if (v.length === 4)
    // 000-0
    v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

  if (v.length === 3)
    // 00-0
    v = v.replace(/(\d{2})(\d{1,2})$/, "$1-$2");

  if (v.length === 2)
    // 0-0
    v = v.replace(/(\d{1})(\d{1,2})$/, "$1-$2");

  return v;
}

export {
  numberToReal,
  leech,
  cep,
  soNumeros,
  telefone,
  cpf,
  mdata,
  mcc,
  cga,
  imoveis,
};
